import { Injectable } from "@angular/core";
import * as braze from "@braze/web-sdk";
import { environment } from "environments/environment";

@Injectable({
  providedIn: "root",
})
export class BrazeService {
  private initialized = false;

  init(): void {
    if (this.initialized || !environment.BRAZE_ENABLED) {
      return;
    }

    try {
      braze.initialize(environment.BRAZE_API_KEY, {
        baseUrl: environment.BRAZE_SDK_ENDPOINT,
        noCookies: true,
      });
      this.initialized = true;
    } catch (error) {
      console.error("Error initializing Braze:", error);
    }
  }

  smsOptInForUser(userId: string, userPhoneNumber: string): void {
    if (!environment.BRAZE_ENABLED) {
      return;
    }

    try {
      braze.changeUser(userId);
      braze.openSession();
      braze.getUser().setPhoneNumber(userPhoneNumber);
      braze.getUser().setCustomUserAttribute("smsOptIn", new Date());
      braze.getUser().addToSubscriptionGroup(environment.BRAZE_SUB_GROUP_ID);
      braze.requestImmediateDataFlush();
    } catch (error) {
      console.error("Error opting user into SMS:", error);
    }
  }

  smsOptOutForUser(userId: string, userPhoneNumber: string): void {
    if (!environment.BRAZE_ENABLED) {
      return;
    }

    try {
      braze.changeUser(userId);
      braze.getUser().setPhoneNumber(userPhoneNumber);
      braze.getUser().setCustomUserAttribute("smsOptOut", new Date());
      braze.requestImmediateDataFlush();
    } catch (error) {
      console.error("Error opting user out of SMS:", error);
    }
  }
}
